export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '8fb11dc5-ee19-48da-b578-086e2ee71109';
export const MODAL_CLOSE_SEC = 2.5;
